 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1COVER from '@/components/Book1/cover'
 import BOOK1TITLE from '@/components/Book1/title'
 import BOOK1DED from '@/components/Book1/ded'
 import BOOK1CONTENT from '@/components/Book1/content'
 import BOOK1PROLOGUE from '@/components/Book1/Prologue'
 import BOOK1PART_ONE from '@/components/Book1/Part_One'
 import BOOK1CHAP1 from '@/components/Book1/chap1'
 import BOOK1CHAP2 from '@/components/Book1/chap2'
 import BOOK1CHAP3 from '@/components/Book1/chap3'
 import BOOK1CHAP4 from '@/components/Book1/chap4'
 import BOOK1CHAP5 from '@/components/Book1/chap5'
 import BOOK1CHAP6 from '@/components/Book1/chap6'
 import BOOK1PART_TWO from '@/components/Book1/Part_Two'
 import BOOK1CHAP7 from '@/components/Book1/chap7'
 import BOOK1CHAP8 from '@/components/Book1/chap8'
 import BOOK1CHAP9 from '@/components/Book1/chap9'
 import BOOK1CHAP10 from '@/components/Book1/chap10'
 import BOOK1CHAP11 from '@/components/Book1/chap11'
 import BOOK1CHAP12 from '@/components/Book1/chap12'
 import BOOK1CHAP13 from '@/components/Book1/chap13'
 import BOOK1PART_THREE from '@/components/Book1/Part_Three'
 import BOOK1CHAP14 from '@/components/Book1/chap14'
 import BOOK1CHAP15 from '@/components/Book1/chap15'
 import BOOK1CHAP16 from '@/components/Book1/chap16'
 import BOOK1CHAP17 from '@/components/Book1/chap17'
 import BOOK1CHAP18 from '@/components/Book1/chap18'
 import BOOK1PART_FOUR from '@/components/Book1/Part_Four'
 import BOOK1CHAP19 from '@/components/Book1/chap19'
 import BOOK1CHAP20 from '@/components/Book1/chap20'
 import BOOK1CHAP21 from '@/components/Book1/chap21'
 import BOOK1CHAP22 from '@/components/Book1/chap22'
 import BOOK1CHAP23 from '@/components/Book1/chap23'
 import BOOK1CHAP24 from '@/components/Book1/chap24'
 import BOOK1CHAP25 from '@/components/Book1/chap25'
 import BOOK1CHAP26 from '@/components/Book1/chap26'
 import BOOK1PART_FIVE from '@/components/Book1/Part_Five'
 import BOOK1CHAP27 from '@/components/Book1/chap27'
 import BOOK1CHAP28 from '@/components/Book1/chap28'
 import BOOK1CHAP29 from '@/components/Book1/chap29'
 import BOOK1CHAP30 from '@/components/Book1/chap30'
 import BOOK1CHAP31 from '@/components/Book1/chap31'
 import BOOK1CHAP32 from '@/components/Book1/chap32'
 import BOOK1CHAP33 from '@/components/Book1/chap33'
 import BOOK1CHAP34 from '@/components/Book1/chap34'
 import BOOK1EPILOGUE from '@/components/Book1/Epilogue'
 import BOOK1ACKNOWLEDGMENTS from '@/components/Book1/Acknowledgments'
 import BOOK2COVER from '@/components/Book2/cover'
 import BOOK2TITLE from '@/components/Book2/title'
 import BOOK2DED from '@/components/Book2/ded'
 import BOOK2CONTENTS from '@/components/Book2/contents'
 import BOOK2PRO from '@/components/Book2/pro'
 import BOOK2PARTONE from '@/components/Book2/partone'
 import BOOK2CH1 from '@/components/Book2/ch1'
 import BOOK2CH2 from '@/components/Book2/ch2'
 import BOOK2CH3 from '@/components/Book2/ch3'
 import BOOK2CH4 from '@/components/Book2/ch4'
 import BOOK2CH5 from '@/components/Book2/ch5'
 import BOOK2CH6 from '@/components/Book2/ch6'
 import BOOK2CH7 from '@/components/Book2/ch7'
 import BOOK2CH8 from '@/components/Book2/ch8'
 import BOOK2CH9 from '@/components/Book2/ch9'
 import BOOK2PARTTWO from '@/components/Book2/parttwo'
 import BOOK2CH10 from '@/components/Book2/ch10'
 import BOOK2CH11 from '@/components/Book2/ch11'
 import BOOK2CH12 from '@/components/Book2/ch12'
 import BOOK2CH13 from '@/components/Book2/ch13'
 import BOOK2CH14 from '@/components/Book2/ch14'
 import BOOK2CH15 from '@/components/Book2/ch15'
 import BOOK2CH16 from '@/components/Book2/ch16'
 import BOOK2CH17 from '@/components/Book2/ch17'
 import BOOK2CH18 from '@/components/Book2/ch18'
 import BOOK2CH19 from '@/components/Book2/ch19'
 import BOOK2PARTTHREE from '@/components/Book2/partthree'
 import BOOK2CH20 from '@/components/Book2/ch20'
 import BOOK2CH21 from '@/components/Book2/ch21'
 import BOOK2CH22 from '@/components/Book2/ch22'
 import BOOK2CH23 from '@/components/Book2/ch23'
 import BOOK2CH24 from '@/components/Book2/ch24'
 import BOOK2CH25 from '@/components/Book2/ch25'
 import BOOK2CH26 from '@/components/Book2/ch26'
 import BOOK2PARTFOUR from '@/components/Book2/partfour'
 import BOOK2CH27 from '@/components/Book2/ch27'
 import BOOK2CH28 from '@/components/Book2/ch28'
 import BOOK2CH29 from '@/components/Book2/ch29'
 import BOOK2CH30 from '@/components/Book2/ch30'
 import BOOK2PARTFIVE from '@/components/Book2/partfive'
 import BOOK2CH31 from '@/components/Book2/ch31'
 import BOOK2CH32 from '@/components/Book2/ch32'
 import BOOK2CH33 from '@/components/Book2/ch33'
 import BOOK2CH34 from '@/components/Book2/ch34'
 import BOOK2CH35 from '@/components/Book2/ch35'
 import BOOK2EPI from '@/components/Book2/epi'
 import BOOK2ACK from '@/components/Book2/ack'
 import BOOK3COVER from '@/components/Book3/cover'
 import BOOK3TIT from '@/components/Book3/tit'
 import BOOK3DED from '@/components/Book3/ded'
 import BOOK3TOC from '@/components/Book3/toc'
 import BOOK3PRO from '@/components/Book3/pro'
 import BOOK3P1 from '@/components/Book3/p1'
 import BOOK3CH1 from '@/components/Book3/ch1'
 import BOOK3CH2 from '@/components/Book3/ch2'
 import BOOK3CH3 from '@/components/Book3/ch3'
 import BOOK3CH4 from '@/components/Book3/ch4'
 import BOOK3CH5 from '@/components/Book3/ch5'
 import BOOK3P2 from '@/components/Book3/p2'
 import BOOK3CH6 from '@/components/Book3/ch6'
 import BOOK3CH7 from '@/components/Book3/ch7'
 import BOOK3CH8 from '@/components/Book3/ch8'
 import BOOK3CH9 from '@/components/Book3/ch9'
 import BOOK3CH10 from '@/components/Book3/ch10'
 import BOOK3CH11 from '@/components/Book3/ch11'
 import BOOK3P3 from '@/components/Book3/p3'
 import BOOK3CH12 from '@/components/Book3/ch12'
 import BOOK3CH13 from '@/components/Book3/ch13'
 import BOOK3CH14 from '@/components/Book3/ch14'
 import BOOK3CH15 from '@/components/Book3/ch15'
 import BOOK3CH16 from '@/components/Book3/ch16'
 import BOOK3CH17 from '@/components/Book3/ch17'
 import BOOK3CH18 from '@/components/Book3/ch18'
 import BOOK3CH19 from '@/components/Book3/ch19'
 import BOOK3P4 from '@/components/Book3/p4'
 import BOOK3CH20 from '@/components/Book3/ch20'
 import BOOK3CH21 from '@/components/Book3/ch21'
 import BOOK3CH22 from '@/components/Book3/ch22'
 import BOOK3CH23 from '@/components/Book3/ch23'
 import BOOK3CH24 from '@/components/Book3/ch24'
 import BOOK3CH25 from '@/components/Book3/ch25'
 import BOOK3P5 from '@/components/Book3/p5'
 import BOOK3CH26 from '@/components/Book3/ch26'
 import BOOK3CH27 from '@/components/Book3/ch27'
 import BOOK3CH28 from '@/components/Book3/ch28'
 import BOOK3CH29 from '@/components/Book3/ch29'
 import BOOK3CH30 from '@/components/Book3/ch30'
 import BOOK3CH31 from '@/components/Book3/ch31'
 import LOVE_2 from '@/components/love_2'
 import BOOK3EPI from '@/components/Book3/epi'
 import BOOK3ACK from '@/components/Book3/ack'
 import COMONPREVIEW from '@/components/Comon/Preview'
 import COMONPREVIEW_COVER from '@/components/Comon/Preview_cover'
 import COMONPREVIEW_1 from '@/components/Comon/Preview_1'
 import COMONPREVIEW_2 from '@/components/Comon/Preview_2'
 import COMONPREVIEW_3 from '@/components/Comon/Preview_3'
 import COMONPREVIEW_4 from '@/components/Comon/Preview_4'
 import COMONAUTHOR from '@/components/Comon/author'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONBACKAD_1 from '@/components/Comon/backad_1'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/cover",
 			"name" : "Book1/cover",
 			"component" : BOOK1COVER
 		},
 		{
 			"path" : "/Book1/title",
 			"name" : "Book1/title",
 			"component" : BOOK1TITLE
 		},
 		{
 			"path" : "/Book1/ded",
 			"name" : "Book1/ded",
 			"component" : BOOK1DED
 		},
 		{
 			"path" : "/Book1/content",
 			"name" : "Book1/content",
 			"component" : BOOK1CONTENT
 		},
 		{
 			"path" : "/Book1/Prologue",
 			"name" : "Book1/Prologue",
 			"component" : BOOK1PROLOGUE
 		},
 		{
 			"path" : "/Book1/Part_One",
 			"name" : "Book1/Part_One",
 			"component" : BOOK1PART_ONE
 		},
 		{
 			"path" : "/Book1/chap1",
 			"name" : "Book1/chap1",
 			"component" : BOOK1CHAP1
 		},
 		{
 			"path" : "/Book1/chap2",
 			"name" : "Book1/chap2",
 			"component" : BOOK1CHAP2
 		},
 		{
 			"path" : "/Book1/chap3",
 			"name" : "Book1/chap3",
 			"component" : BOOK1CHAP3
 		},
 		{
 			"path" : "/Book1/chap4",
 			"name" : "Book1/chap4",
 			"component" : BOOK1CHAP4
 		},
 		{
 			"path" : "/Book1/chap5",
 			"name" : "Book1/chap5",
 			"component" : BOOK1CHAP5
 		},
 		{
 			"path" : "/Book1/chap6",
 			"name" : "Book1/chap6",
 			"component" : BOOK1CHAP6
 		},
 		{
 			"path" : "/Book1/Part_Two",
 			"name" : "Book1/Part_Two",
 			"component" : BOOK1PART_TWO
 		},
 		{
 			"path" : "/Book1/chap7",
 			"name" : "Book1/chap7",
 			"component" : BOOK1CHAP7
 		},
 		{
 			"path" : "/Book1/chap8",
 			"name" : "Book1/chap8",
 			"component" : BOOK1CHAP8
 		},
 		{
 			"path" : "/Book1/chap9",
 			"name" : "Book1/chap9",
 			"component" : BOOK1CHAP9
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js